(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecs-brand-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBrandDirectory(root) {
      if (!root || root.getAttribute('data-ecs-bd-ready') === 'true') { return; }
      root.setAttribute('data-ecs-bd-ready', 'true');

      var filter = root.querySelector('[data-ecs-bd-filter]');
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ecs-bd-chip]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-ecs-bd-item]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ecs-bd-group]'));
      var result = root.querySelector('[data-ecs-bd-result]');
      var empty = root.querySelector('[data-ecs-bd-empty]');
      if (!filter || !chips.length) { return; }

      var handles = chips.map(function (c) { return c.getAttribute('data-ecs-bd-chip'); });

      function labelFor(handle) {
        for (var i = 0; i < chips.length; i++) {
          if (chips[i].getAttribute('data-ecs-bd-chip') === handle) { return chips[i].getAttribute('data-label'); }
        }
        return '';
      }

      function apply(handle, updateHash) {
        if (handles.indexOf(handle) === -1) { handle = 'all'; }
        var shown = 0;
        items.forEach(function (li) {
          var cats = ' ' + (li.getAttribute('data-categories') || '') + ' ';
          var match = handle === 'all' || cats.indexOf(' ' + handle + ' ') !== -1;
          li.hidden = !match;
          if (match) { shown++; }
        });
        groups.forEach(function (g) {
          g.hidden = !g.querySelector('[data-ecs-bd-item]:not([hidden])');
        });
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', c.getAttribute('data-ecs-bd-chip') === handle ? 'true' : 'false');
        });
        var noun = shown === 1 ? 'brand' : 'brands';
        result.textContent = handle === 'all'
          ? 'Showing ' + shown + ' ' + noun
          : 'Showing ' + shown + ' ' + noun + ' for ' + labelFor(handle);
        if (empty) { empty.hidden = shown !== 0; }
        if (updateHash && window.history && history.replaceState) {
          var url = location.pathname + location.search + (handle === 'all' ? '' : '#' + handle);
          history.replaceState(null, '', url);
        }
      }

      chips.forEach(function (c) {
        c.addEventListener('click', function () { apply(c.getAttribute('data-ecs-bd-chip'), true); });
      });

      filter.hidden = false;
      var start = (location.hash || '').replace('#', '');
      apply(start, false);
    }

    function run() {
      var roots = document.querySelectorAll('[data-ecs-bd]');
      for (var i = 0; i < roots.length; i++) { initBrandDirectory(roots[i]); }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
    else { run(); }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecs-brand-hero"] && !Shopify.designMode) return;
  try {
    
function ecsBrandHeroInit(root) {
  if (!root || root.getAttribute('data-ecs-bh-ready') === 'true') { return; }
  root.setAttribute('data-ecs-bh-ready', 'true');
  var sectionId = root.getAttribute('data-section-id');

  var track  = root.querySelector('[data-ecs-bh-track]');
  var stage  = root.querySelector('[data-ecs-bh-stage]');
  var spread = root.querySelector('[data-ecs-bh-spread]');
  var centre = root.querySelector('[data-ecs-bh-centre]');
  var count  = root.querySelector('[data-ecs-bh-count]');
  var slots  = Array.prototype.slice.call(root.querySelectorAll('[data-ecs-bh-slot]'));
  var cards  = Array.prototype.slice.call(root.querySelectorAll('[data-ecs-bh-card]'));
  var names  = Array.prototype.slice.call(root.querySelectorAll('[data-ecs-bh-name]'));
  var n = cards.length;
  /* Needs at least two cards. */
  if (!track || !stage || !spread || n < 2) { return; }
  if (!window.requestAnimationFrame || !('IntersectionObserver' in window)) { return; }

  var ANIM    = root.getAttribute('data-ecs-bh-animate') === 'true';
  var SNAP_ON = root.getAttribute('data-ecs-bh-snap') === 'true';
  var SMOOTH  = (parseFloat(root.getAttribute('data-ecs-bh-scrub')) || 0) * 1000;
  var LEAN_K  = parseFloat(root.getAttribute('data-ecs-bh-lean'));
  var RISE    = parseFloat(root.getAttribute('data-ecs-bh-rise'));
  var FROM_S  = parseFloat(root.getAttribute('data-ecs-bh-scale'));
  var WORD    = root.getAttribute('data-ecs-bh-count-word') || 'Dealt';
  if (isNaN(LEAN_K)) { LEAN_K = 1; }
  if (isNaN(RISE))   { RISE = 3; }
  if (isNaN(FROM_S)) { FROM_S = 0.9; }

  var LEAN = [-6, 4, -3, 7, -8, 2, 5, -4];
  var RING = [0, 1, 2, 4, 7, 6, 5, 3];
  var ORDER = [];
  var i, k;
  for (i = 0; i < RING.length; i++) { if (RING[i] < n) { ORDER.push(RING[i]); } }
  for (i = 0; i < n; i++) { if (ORDER.indexOf(i) === -1) { ORDER.push(i); } }

  var STEP_OF = new Array(n);
  for (i = 0; i < ORDER.length; i++) { STEP_OF[ORDER[i]] = i; }

  function now() {
    return (window.performance && performance.now) ? performance.now() : Date.now();
  }
  function clamp(lo, hi, v) { return v < lo ? lo : (v > hi ? hi : v); }
  function pad(v) { return (v < 10 ? '0' : '') + v; }

  function r4(v) { return Math.round(v * 1e4) / 1e4; }

  function expoOut(p) {
    if (p >= 1) { return 1; }
    if (p <= 0) { return 0; }
    return 1 - Math.pow(2, -10 * p);
  }
  /* Cubic ease in and out. */
  function power2InOut(p) {
    return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
  }
  function power1InOut(p) {
    return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
  }

  var DX = new Array(n), DY = new Array(n);

  function measure() {
    var cx, cy;
    if (centre) {
      cx = centre.offsetLeft + centre.offsetWidth / 2;
      cy = centre.offsetTop + centre.offsetHeight / 2;
    } else {
      cx = spread.offsetWidth / 2;
      cy = spread.offsetHeight / 2;
    }
    for (var j = 0; j < n; j++) {
      var slot = slots[j];
      var well = slot.querySelector('.ecs-bh__well') || slot;
      DX[j] = cx - (slot.offsetLeft + well.offsetLeft + well.offsetWidth / 2);
      DY[j] = cy - (slot.offsetTop + well.offsetTop + well.offsetHeight / 2);
    }
  }

  /* painting */
  var lastCount = '';
  var nPad = pad(n);

  function paint(t) {
    for (var j = 0; j < n; j++) {
      var step = STEP_OF[j];
      var u = clamp(0, 1, t - step);
      var card = cards[j];
      if (u >= 1) {
        
        card.style.transform = 'translate(0px, 0px)';
      } else {
        var e = power2InOut(u);
        var x  = r4(DX[j] * (1 - e));
        var y  = r4((DY[j] - step * RISE) * (1 - e));
        var rz = r4(LEAN[step % LEAN.length] * LEAN_K * (1 - e));
        var ry = r4(180 * (1 - e));
        var sc = r4(FROM_S + (1 - FROM_S) * e);
        card.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0px) rotate('
          + rz + 'deg) rotateY(' + ry + 'deg) scale(' + sc + ', ' + sc + ')';
      }
      card.style.zIndex = (t > step + 0.01) ? (n + step + 1) : (n - step + 1);
      if (names[j]) {
        names[j].style.opacity = r4(clamp(0, 1, (t - (step + 0.75)) / 0.25));
      }
    }
    if (count) {
      var txt = WORD + ' ' + pad(Math.floor(clamp(0, n, t) + 0.001)) + ' / ' + nPad;
      if (txt !== lastCount) { count.textContent = txt; lastCount = txt; }
    }
  }

  function clear() {
    for (var j = 0; j < n; j++) {
      cards[j].style.transform = '';
      cards[j].style.zIndex = '';
      if (names[j]) { names[j].style.opacity = ''; }
    }
    if (count) { count.textContent = WORD + ' 00 / ' + nPad; lastCount = ''; }
  }

  function runway() {
    return Math.round(track.offsetHeight - window.innerHeight);
  }
  function progress() {
    var run = runway();
    if (run <= 0) { return 0; }
    return clamp(0, 1, -track.getBoundingClientRect().top / run);
  }

  /* ScrollTrigger's snap, transcribed */
  var INC = 1 / n;
  var STILL = 300;
  function docScroll() {
    return window.pageYOffset
      || (document.documentElement && document.documentElement.scrollTop) || 0;
  }
  var sc1 = 0, sc2 = 0, tm1 = 0, tm2 = 0, sp1 = 0, sp2 = 0;
  var lastMoveT = 0, lastPos = null, lastP = -1, dir = 1;
  var lastRefresh = 0, lastSnap = -1, snapTimer = 0, pointerDown = false;
  var snapOn = false, snapT0 = 0, snapFrom = 0, snapC1 = 0, snapC2 = 0;
  var snapDur = 0, snapWrote = 0, snapEnd = 0, snapWorks = true;

  function killSnap() { snapOn = false; }

  function snapDirectional(value, direction) {
    var snapped = Math.round(value / INC) * INC;
    if (!direction || Math.abs(snapped - value) < 1e-3
        || ((snapped - value < 0) === (direction < 0))) { return snapped; }
    var pushed = direction < 0 ? value - INC : value + INC;
    return Math.round(pushed / INC) * INC;
  }

  function trySnap(t, sy) {
    var vel = (sy - sc2) / (t - tm2) * 1000 || 0;
    var fresh = (t - lastRefresh) < 500;
    if ((fresh || Math.abs(vel) < 10) && !snapOn && !pointerDown && lastSnap !== sy) {
      var change = runway();
      if (change <= 0) { return; }
      var start = Math.round(sy + track.getBoundingClientRect().top);
      var prog = (sy - start) / change;
      var tp = cur;
      var velocity = fresh ? 0 : (tp - sp2) / (t - tm2) * 1000 || 0;
      var c1 = clamp(-prog, 1 - prog, Math.abs(velocity / 2) * velocity / 0.185);
      var natural = prog + c1;
      var endValue = snapDirectional(natural, fresh ? 0 : dir);
      var endScroll = Math.round(start + endValue * change);
      if (sy <= start + change && sy >= start && endScroll !== sy) {
        var d = Math.abs(Math.max(Math.abs(natural - tp), Math.abs(endValue - tp))
                         * 0.185 / velocity / 0.05 || 0);
        snapDur = clamp(0.2, 0.6, d) * 1000;
        snapC1 = c1 * change;
        if (!snapC1) { snapC1 = endScroll - sy; snapC2 = 0; }
        else { snapC2 = endScroll - sy - snapC1; }
        snapFrom = sy;
        snapEnd = endValue;
        snapWrote = sy;
        snapT0 = t;
        snapOn = true;
      }
    } else if (lastP > 0 && lastP < 1 && lastSnap !== sy) {
      snapTimer = t + 50;
    }
  }

  function stepSnap(t, sy) {
    if (Math.abs(sy - snapWrote) > 2) { snapOn = false; return; }
    var e = (t - snapT0) / snapDur;
    if (e > 1) { e = 1; }
    var r = power1InOut(e);
    var y = snapFrom + snapC1 * r + snapC2 * r * r;
    window.scrollTo(0, y);
    var got = docScroll();
    
    if (Math.abs(y - sy) > 1 && got === sy) { snapWorks = false; snapOn = false; return; }
    snapWrote = got;
    if (e >= 1) {
      snapOn = false;
      lastSnap = got;
      
      from = to = cur = snapEnd;
      t0 = t - SMOOTH - 1;
      lastP = progress();
      sp1 = sp2 = cur;
    }
  }

  /* the loop */
  var live = false, raf = null, io = null;
  var cur = 0, from = 0, to = 0, t0 = 0, tPrev = 0, shownPrev = -1;

  function tick() {
    var t = now();
    var p = progress();
    var prevCur = cur;
    var sy = docScroll();

    if (lastPos === null || sy !== lastPos) { lastPos = sy; lastMoveT = t; }

    if ((t - tm1) >= 50) {
      sc2 = sc1; sc1 = sy;
      sp2 = sp1; sp1 = prevCur;
      tm2 = tm1; tm1 = t;
    }

    if (p !== lastP) {
      if (lastP >= 0) { dir = p > lastP ? 1 : -1; }
      lastP = p;
      from = cur;
      to = p;
      t0 = tPrev || t;
      if (SNAP_ON && snapWorks && !snapOn) { snapTimer = t + 50; }
    }

    var v;
    if (SMOOTH > 0) {
      var e = (t - t0) / SMOOTH;
      v = e >= 1 ? to : from + (to - from) * expoOut(e);
    } else {
      v = to;
    }
    cur = v;
    tPrev = t;

    var shown = (shownPrev < 0) ? v : (v + shownPrev) / 2;
    shownPrev = v;

    paint(shown * n);

    if (snapOn) { stepSnap(t, sy); }
    else if (SNAP_ON && snapWorks && snapTimer && t >= snapTimer) {
      
      if ((t - lastMoveT) < STILL) { snapTimer = t + 50; }
      else { snapTimer = 0; trySnap(t, sy); }
    }
  }

  function loop() { tick(); raf = window.requestAnimationFrame(loop); }
  function play() { if (raf === null) { raf = window.requestAnimationFrame(loop); } }
  function halt() { if (raf !== null) { window.cancelAnimationFrame(raf); raf = null; } }

  function settle() {
    var p = progress();
    from = to = cur = p;
    shownPrev = p;
    t0 = now() - SMOOTH - 1;
    lastP = p;
    paint(p * n);
  }

  function remeasure() {
    if (!live) { return; }
    measure();
    lastRefresh = now();
    tick();
  }

  function enable() {
    if (live) { return; }
    live = true;
    root.classList.add('ecs-bh--deal');
    cur = 0; from = 0; to = 0; t0 = now() - SMOOTH - 1; tPrev = 0; shownPrev = -1;
    lastP = -1; lastCount = ''; lastSnap = -1; snapOn = false; snapTimer = 0;
    lastPos = null;
    measure();
    lastRefresh = now();
    settle();
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) { play(); } else { halt(); settle(); }
        }
      }, { rootMargin: '200px 0px' });
    }
    io.observe(root);
  }

  function disable() {
    if (!live) { return; }
    live = false;
    halt();
    snapOn = false;
    if (io) { io.unobserve(root); }
    root.classList.remove('ecs-bh--deal');
    clear();
  }

  var gate = window.matchMedia
    ? window.matchMedia('(min-width: 768px) and (prefers-reduced-motion: no-preference)')
    : null;

  function sync() {
    if (ANIM && gate && gate.matches) { enable(); } else { disable(); }
  }

  if (gate) {
    sync();
    if (gate.addEventListener) { gate.addEventListener('change', sync); }
    else if (gate.addListener) { gate.addListener(sync); }

    window.addEventListener('resize', remeasure, { passive: true });
    window.addEventListener('load', remeasure);
    if ('ResizeObserver' in window) { new ResizeObserver(remeasure).observe(root); }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(remeasure)['catch'](function () {});
    }

    window.addEventListener('wheel', killSnap, { passive: true });
    window.addEventListener('touchmove', killSnap, { passive: true });
    window.addEventListener('touchstart', function () { pointerDown = true; }, { passive: true });
    window.addEventListener('touchend', function () { pointerDown = false; }, { passive: true });
    window.addEventListener('touchcancel', function () { pointerDown = false; }, { passive: true });

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:unload', function (ev) {
        if (ev.detail && ev.detail.sectionId === sectionId) { disable(); }
      });
      document.addEventListener('shopify:block:select', function (ev) {
        if (!live || !ev.target) { return; }
        var slot = ev.target.closest ? ev.target.closest('[data-ecs-bh-slot]') : null;
        if (!slot) { return; }
        var idx = slots.indexOf(slot);
        if (idx < 0) { return; }
        var want = (STEP_OF[idx] + 1) / n;
        var run = runway();
        if (run > 0) {
          window.scrollTo(0, Math.round(docScroll() + track.getBoundingClientRect().top + want * run));
        }
      });
    }
  }
}

(function () {
  function run() {
    var roots = document.querySelectorAll('[data-ecs-bh]');
    for (var i = 0; i < roots.length; i++) { ecsBrandHeroInit(roots[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
  else { run(); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecs-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var select = document.querySelector('[data-ecs-contact-type]');
      var orderField = document.querySelector('[data-ecs-contact-order]');
      if (select && orderField) {
        var update = function () { orderField.hidden = select.value !== 'An existing order'; };
        select.addEventListener('change', update);
        update();
      }
      var focusTarget = document.querySelector('[data-ecs-contact-errors]') || document.querySelector('[data-ecs-contact-success]');
      if (focusTarget) { focusTarget.focus(); }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecs-help-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('[data-ecs-help]');
      if (!root) { return; }
      var rates = root.querySelector('[data-ecs-help-rates]');
      if (rates) {
        var list = rates.querySelector('[data-ecs-help-tablist]');
        var tabs = rates.querySelectorAll('[data-ecs-help-tab]');
        var panels = rates.querySelectorAll('[data-ecs-help-panel]');
        if (list && tabs.length && tabs.length === panels.length) {
          rates.classList.add('ecs-help-js');
          list.hidden = false;
          var select = function (index, focus) {
            for (var i = 0; i < tabs.length; i++) {
              var on = i === index;
              tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
              tabs[i].tabIndex = on ? 0 : -1;
              panels[i].hidden = !on;
            }
            if (focus) { tabs[index].focus(); }
          };
          select(0, false);
          for (var t = 0; t < tabs.length; t++) {
            (function (i) {
              tabs[i].addEventListener('click', function () { select(i, false); });
              tabs[i].addEventListener('keydown', function (e) {
                var next = null;
                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (i + 1) % tabs.length; }
                else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (i - 1 + tabs.length) % tabs.length; }
                else if (e.key === 'Home') { next = 0; }
                else if (e.key === 'End') { next = tabs.length - 1; }
                if (next !== null) { e.preventDefault(); select(next, true); }
              });
            })(t);
          }
        }
      }
      var sub = root.querySelector('[data-ecs-help-suburbs]');
      if (sub) {
        var box = sub.querySelector('[data-ecs-help-search]');
        var input = sub.querySelector('[data-ecs-help-input]');
        var items = sub.querySelectorAll('[data-ecs-help-item]');
        var groups = sub.querySelectorAll('[data-ecs-help-group]');
        var none = sub.querySelector('[data-ecs-help-nomatch]');
        if (box && input) {
          box.hidden = false;
          input.addEventListener('input', function () {
            var q = input.value.trim().toLowerCase();
            var shown = 0;
            for (var i = 0; i < items.length; i++) {
              var hit = !q || items[i].getAttribute('data-search').indexOf(q) !== -1;
              items[i].hidden = !hit;
              if (hit) { shown++; }
            }
            for (var g = 0; g < groups.length; g++) {
              groups[g].hidden = !groups[g].querySelector('[data-ecs-help-item]:not([hidden])');
            }
            if (none) { none.hidden = shown > 0; }
          });
        }
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  $(".disclosure__link").on("click",function(e){
    let value = $(this).children().text()
    value = value.replace(/\(|\)/g, '').split(" ")[1];
    localStorage.setItem("money",value)
  })
  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
        icon: this.querySelector('.icon.icon-caret'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

       if(this.elements.button.getAttribute('aria-expanded') === 'true'){
         $("body").addClass("showBefore");
         this.elements.icon.style.transform = "rotate(180deg)";
      }else{
         $("body").removeClass("showBefore");
           this.elements.icon.style.transform = "rotate(0deg)";
        }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
      $("body").removeClass("showBefore");
      this.elements.icon.style.transform = "rotate(0deg)";
    }
  }

  customElements.define('localization-form', LocalizationForm);


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-delivery-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('.ecs-local-delivery');
      if (!root) { return; }
      var box = root.querySelector('[data-ecs-ld-search]');
      var input = root.querySelector('[data-ecs-ld-input]');
      var items = root.querySelectorAll('[data-ecs-ld-item]');
      var groups = root.querySelectorAll('[data-ecs-ld-group]');
      var none = root.querySelector('[data-ecs-ld-nomatch]');
      if (box && input) {
        box.hidden = false;
        input.addEventListener('input', function () {
          var q = input.value.trim().toLowerCase();
          var shown = 0;
          for (var i = 0; i < items.length; i++) {
            var hit = !q || items[i].getAttribute('data-search').indexOf(q) !== -1;
            items[i].hidden = !hit;
            if (hit) { shown++; }
          }
          for (var g = 0; g < groups.length; g++) {
            var any = groups[g].querySelector('[data-ecs-ld-item]:not([hidden])');
            groups[g].hidden = !any;
          }
          if (none) { none.hidden = shown > 0; }
        });
      }
      var chat = document.querySelector('shopify-chat');
      var links = root.querySelectorAll('[data-ecs-ld-chat]');
      for (var c = 0; c < links.length; c++) {
        links[c].addEventListener('click', function (e) { e.preventDefault(); if (chat) { chat.open = true; } });
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["returns-policy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var chat = document.querySelector('shopify-chat');
      var buttons = document.querySelectorAll('[data-ecs-returns-chat]');
      for (var i = 0; i < buttons.length; i++) {
        if (!chat) { buttons[i].hidden = true; continue; }
        buttons[i].addEventListener('click', function () { chat.open = true; });
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('[data-ecs-shipping]');
      if (!root) { return; }
      var list = root.querySelector('[data-ecs-sh-tablist]');
      var tabs = root.querySelectorAll('[data-ecs-sh-tab]');
      var panels = root.querySelectorAll('[data-ecs-sh-panel]');
      if (list && tabs.length && tabs.length === panels.length) {
        root.classList.add('ecs-sh-js');
        list.hidden = false;
        var select = function (index, focus) {
          for (var i = 0; i < tabs.length; i++) {
            var on = i === index;
            tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
            tabs[i].tabIndex = on ? 0 : -1;
            panels[i].hidden = !on;
          }
          if (focus) { tabs[index].focus(); }
        };
        select(0, false);
        for (var t = 0; t < tabs.length; t++) {
          (function (i) {
            tabs[i].addEventListener('click', function () { select(i, false); });
            tabs[i].addEventListener('keydown', function (e) {
              var next = null;
              if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (i + 1) % tabs.length; }
              else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (i - 1 + tabs.length) % tabs.length; }
              else if (e.key === 'Home') { next = 0; }
              else if (e.key === 'End') { next = tabs.length - 1; }
              if (next !== null) { e.preventDefault(); select(next, true); }
            });
          })(t);
        }
      }
      var chat = document.querySelector('shopify-chat');
      var links = root.querySelectorAll('[data-ecs-sh-chat]');
      for (var c = 0; c < links.length; c++) {
        links[c].addEventListener('click', function (e) { e.preventDefault(); if (chat) { chat.open = true; } });
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  } catch(e) { console.error(e); }
})();
})();
